import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { calculateFinMapleScore } from '../../utils/finmapleScore';

const getScoreTheme = (total) => {
  if (total >= 4.5) return { color: '#2E7D32', bg: 'rgba(46,125,50,0.08)' };
  if (total >= 4.0) return { color: '#1E3A5F', bg: 'rgba(30,58,95,0.06)' };
  return { color: '#F9A825', bg: 'rgba(249,168,37,0.08)' };
};

const FinMapleScoreBadge = ({ card }) => {
  const { total, breakdown } = calculateFinMapleScore(card);
  const { color, bg } = getScoreTheme(total);

  const tooltipTitle = `¿Por qué ${total.toFixed(1)}?  Costos: ${breakdown.costos} | Newcomers: ${breakdown.newcomer} | Beneficios: ${breakdown.beneficios} | Digital: ${breakdown.digital} | Español: ${breakdown.espanol}`;

  return (
    <Tooltip title={tooltipTitle} arrow placement="top">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5, cursor: 'help' }}>
        {/* Circular score ring */}
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            border: '2.5px solid',
            borderColor: color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: bg,
            flexShrink: 0,
          }}
        >
          <Typography
            sx={{ fontWeight: 700, fontFeatureSettings: "'tnum'", color, fontSize: '0.85rem', lineHeight: 1 }}
          >
            {total.toFixed(1)}
          </Typography>
        </Box>
        {/* Label + mini bar */}
        <Box>
          <Typography
            variant="caption"
            sx={{ color: '#5F6B7A', fontSize: '0.7rem', lineHeight: 1.2, display: 'block', fontWeight: 600 }}
          >
            FinMaple Score
          </Typography>
          <Box sx={{ width: 48, height: 3, borderRadius: 2, bgcolor: 'rgba(0,0,0,0.06)', mt: 0.3 }}>
            <Box
              sx={{
                width: `${(total / 5) * 100}%`,
                height: '100%',
                borderRadius: 2,
                bgcolor: color,
                transition: 'width 0.3s ease',
              }}
            />
          </Box>
        </Box>
      </Box>
    </Tooltip>
  );
};

export default FinMapleScoreBadge;
